(function () {
    var cache = {};

    function newSectionId() {
        return 'cl' + Date.now() + Math.floor(Math.random() * 1000);
    }

    function fetchCard(handle) {
        if (cache[handle]) return cache[handle];
        var root = (window.routes && window.routes.root) ? window.routes.root : '';
        cache[handle] = fetch(root + '/products/' + handle + '?view=ajax_combined_card')
            .then(function (r) { return r.text(); });
        return cache[handle];
    }

    function fixIds(card, sectionId) {
        card.querySelectorAll('.variants-popup-content .selector-wrapper .swatch-element').forEach(function (el) {
            var input = el.querySelector('input');
            var label = el.querySelector('label');
            if (input) {
                input.setAttribute('id', (input.getAttribute('id') || '') + sectionId);
                input.setAttribute('name', (input.getAttribute('name') || '') + sectionId);
            }
            if (label) label.setAttribute('for', (label.getAttribute('for') || '') + sectionId);
        });

        var qsForm = card.querySelector('.variants-popup-content form');
        var acForm = card.querySelector('.card-action form');
        var select = card.querySelector('.variants-popup-content select');
        var acButton = card.querySelector('.card-action form button');
        var qsButton = card.querySelector('.variants-popup-content .product-card__button2 button');

        if (qsForm) qsForm.setAttribute('id', (qsForm.getAttribute('id') || '') + sectionId);
        if (acForm) acForm.setAttribute('id', (acForm.getAttribute('id') || '') + sectionId);
        if (select) select.setAttribute('id', (select.getAttribute('id') || '') + sectionId);
        if (acButton) acButton.setAttribute('data-form-id', (acButton.getAttribute('data-form-id') || '') + sectionId);
        if (qsButton) qsButton.setAttribute('data-form-id', (qsButton.getAttribute('data-form-id') || '') + sectionId);
    }

    function setSrc(img, url) {
        if (!img || !url) return;
        img.setAttribute('src', url);
        img.setAttribute('srcset', url);
        img.setAttribute('data-srcset', url);
    }

    function setTitleColor(card, colorName) {
        var titleEl = card.querySelector('.card-title');
        if (!titleEl) return;
        var span = titleEl.querySelector('[data-change-title]');
        if (!colorName) {
            if (span) span.remove();
            return;
        }
        if (!span) {
            span = document.createElement('span');
            span.setAttribute('data-change-title', '');
            titleEl.appendChild(span);
        }
        span.textContent = ' ' + colorName;
        titleEl.classList.add('card-title-change');
    }

    function preview(link) {
        var card = link.closest('.product-item');
        if (!card) return;

        var imgs = card.querySelectorAll('.card-media img');
        var main = link.getAttribute('data-main-image');
        var hover = link.getAttribute('data-hover-image') || main;
        setSrc(imgs[0], main);
        setSrc(imgs[1], hover);

        var url = link.getAttribute('data-product-url');
        var title = link.getAttribute('data-product-title');

        card.querySelectorAll('.card-link, .card-title, .view-details').forEach(function (a) {
            if (url) a.setAttribute('href', url);
        });

        var titleEl = card.querySelector('.card-title');
        if (titleEl && title) titleEl.textContent = title;
        setTitleColor(card, link.getAttribute('data-color-name'));

        card.querySelectorAll('.item-custom').forEach(function (li) {
            li.classList.remove('current-item');
        });
        var current = link.closest('.item-custom');
        if (current) current.classList.add('current-item');
    }

    function swapCard(link) {
        var card = link.closest('.product-item');
        var handle = link.getAttribute('data-product-handle');
        if (!card || !handle) return;

        preview(link);

        var sectionId = newSectionId();

        fetchCard(handle)
            .then(function (html) {
                var tmp = document.createElement('div');
                tmp.innerHTML = html;
                var newCard = tmp.querySelector('.product-item');
                if (!newCard || !card.parentNode) return;

                fixIds(newCard, sectionId);
                card.parentNode.replaceChild(newCard, card);

                var activeLink = newCard.querySelector('.item-custom.current-item [data-combined-swatch]');
                if (activeLink) setTitleColor(newCard, activeLink.getAttribute('data-color-name'));

                if (window.halo) {
                    if (typeof halo.swapHoverVideoProductCard === 'function') halo.swapHoverVideoProductCard();
                    if (window.wishlist && window.wishlist.show && typeof halo.setLocalStorageProductForWishlist === 'function') {
                        halo.setLocalStorageProductForWishlist();
                    }
                }
            })
            .catch(function () {});
    }

    // document.addEventListener('mouseover', function (e) {
    //     var link = e.target.closest('[data-combined-swatch]');
    //     if (!link) return;
    //     var handle = link.getAttribute('data-product-handle');
    //     if (handle) fetchCard(handle);
    // });

    document.addEventListener('mouseover', function (e) {
        var link = e.target.closest('[data-combined-swatch]');
        if (!link) return;
        if (link.closest('[data-swatch-action="redirect"]')) return;
        var handle = link.getAttribute('data-product-handle');
        if (handle) fetchCard(handle);
    });

    // document.addEventListener('click', function (e) {
    //     var link = e.target.closest('[data-combined-swatch]');
    //     if (!link) return;
    //     e.preventDefault();
    //     var li = link.closest('.item-custom');
    //     if (li && li.classList.contains('current-item')) return;
    //     swapCard(link);
    // });

    document.addEventListener('click', function (e) {
        var link = e.target.closest('[data-combined-swatch]');
        if (!link) return;

        var wrap = link.closest('[data-swatch-action]');
        if (wrap && wrap.getAttribute('data-swatch-action') === 'redirect') return;

        e.preventDefault();
        var li = link.closest('.item-custom');
        if (li && li.classList.contains('current-item')) return;
        swapCard(link);
    });

    function initTitles() {
        document.querySelectorAll('.product-item .item-custom.current-item [data-combined-swatch]').forEach(function (link) {
            var card = link.closest('.product-item');
            if (card) setTitleColor(card, link.getAttribute('data-color-name'));
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTitles);
    } else {
        initTitles();
    }
})();